import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from '@pool-league/frontend-shared-ui-common';

export interface PlayerBadgeInfo {
  retired: boolean;
  isMe: boolean;
}

@Component({
  selector: 'lib-web-player-badges',
  imports: [CommonModule, BadgeComponent],
  templateUrl: './player-badges.component.html',
  styleUrl: './player-badges.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayerBadgesComponent {
  readonly player = input.required<PlayerBadgeInfo>();
}
